// helpers/rutaPersona.js
import axios from "axios";

// Base tomada del .env o fallback a producción
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backre-miami.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, ""); // quita / al final
const API = axios.create({ baseURL: BASE_URL });

// arma paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// header con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- PERSONAS ----

// GET: lista (?q=, ?activo=)
export const getPersonas = async (params = {}) => {
  const { data } = await API.get(p("personas"), {
    ...auth(),
    params, // ej: { q: "Juan", activo: true }
  });
  // esperado: { ok, personas, cantidad }
  return data;
};

// GET: una por id
export const getPersonaById = async (id) => {
  const { data } = await API.get(p(`personas/${id}`), auth());
  return data; // { ok, persona }
};

// POST: crear
export const postPersona = async (payload) => {
  const { data } = await API.post(p("personas"), payload, auth());
  return data; // { ok, persona }
};

// PUT: actualizar
export const putPersona = async (id, payload) => {
  const { data } = await API.put(p(`personas/${id}`), payload, auth());
  return data; // { ok, persona }
};

// DELETE: baja lógica (o hard con ?hard=true)
export const deletePersona = async (id, hard = false) => {
  const { data } = await API.delete(p(`personas/${id}`), {
    ...auth(),
    params: hard ? { hard: true } : {},
  });
  return data; // { ok, persona, hard }
};
